import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FormWrapper = styled.div`
  width: 53%;
  padding: 48px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  box-sizing: border-box;
`;

export const FormTitle = styled(typography.H1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const FormSubTitle = styled(typography.P1RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const FormBtnWrapper = styled.div`
  display: flex;
`;

export const FormNextBtn = styled(typography.P2BoldTypography)`
  margin-inline-start: auto;
  padding: 10px 24px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:focus {
    border: none;
  }
`;

export const FormBackBtn = styled(FormNextBtn)`
  display: flex;
  margin-inline-start: 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grey600};
  background-color: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey003};

  &:before {
    content: '\\e902';
    font-family: Icomoon;
    margin-inline-end: 12px;
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey003};
  }
`;
